export enum CommentType {
  Text = 'text',
  Call = 'call',
}
